import Settings from "assets/images/nav/settings.svg";
import Home from "assets/images/nav/home.svg";
import Management from "assets/images/nav/management.svg";
import L360 from "assets/images/nav/360.svg";
import Report from "assets/images/nav/report.svg";
import PDFIcon from "assets/images/nav/pdf-regular-white.svg";

import Culture from "assets/images/nav/culture.svg";
import Mood from "assets/images/nav/mood.svg";
import Personality from "assets/images/nav/personality.svg";

import Leadership from "assets/images/nav/leadership.svg";
import Admin from "assets/images/nav/admin.svg";
import MyMood from "assets/images/group-12.svg";
import Survey from "assets/images/nav/survey.svg";

import Data from "assets/images/nav/data.svg";

import Calendar from "assets/images/nav/calendar.png";
import Action from "assets/images/nav/action.png";

import {
  TeamIcon,
  actionIcon,
  cultureIcon,
  calendarIcon,
  dataScienceIcon,
  groupIcon,
  recommendationIcon,
  outcomesIcon,
  aiIcon,
  dashboardIcon,
  reportIcon,
  analyticsIcon,
  sharingIcon,
  NoraNavIcon,
  staplesReportIcon,
} from "./Icons";

// before you add things here check if the route is valid
// checking this data is done in sidebar.js
// use the name property to loop through
export const CommonNav = [
  {
    icon: "address book",
    link: "/core/management",
    title: "Team Management",
    image: Management,
    role: 7,
    paid: true,
    team: false,
    name: null,
    group: "Common",
  },
];
export const OtpNav = [];

export const NavData = [
  {
    header: "Culture",
    fr_header: "Culture",
    role: 9,
    paid: false,
    team: false,
    name: "Audit",
    group: "Audit",
  },
  // {
  //   icon: "dollar",
  //   link: "/leader/audit/home",
  //   title: "Home",
  //   image: Report,
  //   svg: outcomesIcon,
  //   prototype: false,
  //   role: 5,
  //   paid: true,
  //   team: false,
  //   require_access_data: false,
  //   name: "Audit",
  //   group: "Audit",
  //   innerlogic_only: false,
  //   no_subfactor: true,
  // },
  {
    icon: "dollar",
    link: "/leader/audit/new-analytics",
    title: "Survey Analytics",
    fr_title: "Analyses des sondages",
    image: Report,
    svg: analyticsIcon,
    prototype: true,
    role: 5,
    paid: true,
    team: false,
    require_access_data: true,
    name: "Audit",
    group: "Audit",
    innerlogic_only: false,
    no_subfactor: true,
  },
  {
    icon: "address book",
    link: "/leader/audit/automated-reports",
    title: "My Reports",
    fr_title: "Mes rapports",
    image: null,
    svg: staplesReportIcon,
    role: 9,
    paid: false,
    team: false,
    group: "Common",
    staplesOnly: true,
  },
  // {
  //   icon: "dollar",
  //   link: "/leader/prototype/leaderaccountability",
  //   title: "Accountability",
  //   image: Report,
  //   svg: cultureIcon,
  //   prototype: true,
  //   role: 5,
  //   paid: true,
  //   team: false,
  //   require_access_data: true,
  //   name: "Audit",
  //   group: "Audit",
  //   innerlogic_only:true,
  //   no_subfactor:true,
  // },
  {
    icon: "dollar",
    link: "/leader/audit/AI/copilot",
    title: "Nora AI",
    fr_title: "Nora IA",
    image: Report,
    svg: NoraNavIcon,
    role: 5,
    paid: true,
    team: false,
    require_access_data: true,
    require_nora_ai: true,
    name: "Nora AI",
    group: "Audit",
  },
  // {
  //   icon: "dollar",
  //   link: "/leader/audit/schedule-v2/pulse",
  //   title: "Survey Library",
  //   image: Report,
  //   svg: analyticsIcon,
  //   prototype: true,
  //   role: 9,
  //   paid: true,
  //   team: false,
  //   require_access_data: true,
  //   name: "Pulse Surveys",
  //   group: "Audit",
  //   innerlogic_only: false,
  //   no_subfactor: true,
  // },
  // {
  //   icon: "dollar",
  //   link: "/leader/audit/automated-reports",
  //   title: "Automated Reports",
  //   image: Report,
  //   svg: reportIcon,
  //   prototype: true,
  //   role: 9,
  //   paid: true,
  //   team: false,
  //   require_access_data: true,
  //   name: "Automated Reports",
  //   group: "Audit",
  //   innerlogic_only: false,
  //   no_subfactor: true,
  // },
  // {
  //   icon: "address book",
  //   link: "/leader/audit/AI/copilot",
  //   title: "AI Toolkit",
  //   image: Report,
  //   svg: aiIcon,
  //   role: 9,
  //   paid: true,
  //   team: false,
  //   require_access_data: true,
  //   require_feedback_access: false,
  //   name: "AI",
  //   group: "Audit",
  //   subNav: [
  //     {
  //       link: "/leader/audit/AI/copilot",
  //       title: "Culture Copilot",
  //     },
  //     // {
  //     //   link: "/leader/audit/AI/history",
  //     //   title: "Chat History",
  //     // },
  //     // {
  //     //   link: "/leader/audit/AI/insights",
  //     //   title: "Data Stories",
  //     //   relatedLinks: [
  //     //     "/leader/audit/AI/insight",
  //     //     "/leader/audit/simple/insights",
  //     //     "/leader/audit/AI/insights/insight",
  //     //   ],
  //     //   demo_1:true
  //     // },
  //     {
  //       link: "/leader/audit/schedule-v2/pulse",
  //       title: "Pulse AI",
  //       relatedLinks: [
  //         "/leader/audit/schedule-v2/pulse",
  //         "/leader/audit/manage/tasktemplates",
  //         "/leader/audit/manage/task/report",
  //       ],
  //       demo_1: false,
  //       // beta: true,
  //     },
  //     {
  //       link: "/leader/audit/diagnostic",
  //       title: "Action Planning",
  //       // beta: true,
  //     },
  //     {
  //       link: "/leader/audit/copilot",
  //       title: "Workflow AI",
  //       // beta: true,
  //       demo_1: true,
  //     },
  //     {
  //       link: "/leader/audit/presentation/list",
  //       title: "Presentations",
  //       beta: true,
  //       demo_1: true,
  //     },
  //     {
  //       link: "/leader/audit/AI/relationships",
  //       title: "ROI insights",
  //       beta: true,
  //       demo: true,
  //     },
  //   ],
  // },
  // {
  //   icon: "dollar",
  //   link: "/leader/prototype/groupdata",
  //   title: "BI Toolkit",
  //   image: Report,
  //   svg: cultureIcon,
  //   prototype: true,
  //   role: 5,
  //   paid: true,
  //   team: false,
  //   require_access_data: true,
  //   name: "Audit",
  //   group: "Audit",
  //   innerlogic_only: true,
  //   no_subfactor: true,
  //   beta: true,
  //   subNav: [
  //     // {
  //     //   link: "/leader/audit/bitoolkit/relationships",
  //     //   title: "ROI insights",
  //     //   beta: true,
  //     // },
  //     // {
  //     //   link: "/leader/audit/bitoolkit/analysisdashboard",
  //     //   title: "Business outcomes",
  //     //   required_recommendation: true,
  //     //   beta: true,
  //     //   demo: true,
  //     // },
  //     // {
  //     //   link: "/leader/prototype/modelhistory",
  //     //   title: "Predictive Models",
  //     //   beta: true,
  //     //   demo: true,
  //     // },
  //     {
  //       link: "/leader/prototype/groupdata",
  //       title: "Business Intelligence",
  //       beta: true,
  //       demo: true,
  //     },
  //   ],
  // },
  {
    // icon: "home",
    link: "/leader/audit/schedule-v2",
    title: "Survey Admin",
    fr_title: "Administration de sondages",
    image: Calendar,
    svg: calendarIcon,
    role: 9,
    paid: false,
    team: false,
    name: "Audit",
    group: "Audit",
    require_calendar: true,
  },
/*   {
    icon: "dollar",
    link: null,
    title: "Reports",
    image: Report,
    svg: reportIcon,
    prototype: true,
    role: 5,
    paid: true,
    team: false,
    require_access_data: true,
    require_access_pdf: true,
    name: "Audit",
    group: "Audit",
    innerlogic_only: true,
    no_subfactor: true,
    subNav: [
      {
        link: "/leader/audit/reports",
        title: "PDF Reports",
        demo_1: true,
      },
      {
        link: "/leader/audit/reports/recV4",
        title: "Action Plans",
      },
    ],
  }, */

  // {
  //   icon: "address book",
  //   link: "/leader/audit/pdf",
  //   title: "PDF Report",
  //   image: PDFIcon,
  //   svg: reportIcon,
  //   role: 9,
  //   paid: true,
  //   team: false,
  //   require_access_data: true,
  //   require_access_pdf: true,
  //   name: "Audit",
  //   group: "Audit",
  //   not_for_innerlogic: true,
  // },
  {
    header: "Settings",
    fr_header: "Paramètres",
    role: 6,
    paid: true,
    team: false,
    name: null,
    group: "Common",
  },
  // {
  //   icon: "address book",
  //   link: "/leader/members/list",
  //   title: "Team Management",
  //   fr: "Gestion de l'équipe",
  //   image: Management,
  //   svg: TeamIcon,
  //   border: true,
  //   role: 6,
  //   paid: true,
  //   team: false,
  //   name: null,
  //   require_add_users: true,
  //   group: "Common",
  // },
  {
    icon: "address book",
    link: "/leader/audit/contact-list-v2",
    title: "Contact Directory",
    fr_title: "Répertoire de contacts",
    image: Management,
    svg: TeamIcon,
    border: true,
    role: 6,
    paid: true,
    team: false,
    name: null,
    require_add_users: true,
    group: "Common",
  },
  {
    icon: "lock",
    link: "/leader/audit/access-v2",
    title: "User Management",
    fr_title: "Gestion des utilisateurs",
    svg: groupIcon,
    role: 5,
    paid: true,
    team: false,
    name: null,
    admin: true,
    group: "Common",
  },
];

export default NavData;
